import {
  Homepage,
  ServicesBuildingPage,
  ContactPage,
  ServicesPage,
  AboutUsPage,
  SwadaaSecurityPage,
  SwadaaEmpowermentPage,
  SwadaaExpressPage,
  ProjectsPage,
} from "./pages";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useRoutes,
} from "react-router-dom";

const RoutesE = () => {
  let routes = useRoutes([
    {
      path: "/",
      element: <Homepage />,
    },

    {
      path: "/services",
      element: <ServicesPage />,
    },
    {
      path: "/contact",
      element: <ContactPage />,
    },

    {
      path: "/about_us",
      element: <AboutUsPage />,
    },
    {
      path: "/security",
      element: <SwadaaSecurityPage />,
    },
    {
      path: "/empowerment",
      element: <SwadaaEmpowermentPage />,
    },
    {
      path: "/swadaaexpress",
      element: <SwadaaExpressPage />,
    },
    {
      path: "/projects",
      element: <ProjectsPage />,
    },
  ]);
  return routes;
};

const AppWrapper = () => {
  return (
    <Router>
      <RoutesE />
    </Router>
  );
};

export default AppWrapper;
